import PatientCases from './PatientCases';

export default PatientCases;
